import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import { countriesList, state_list } from 'constants/stateList';
import SubText from '../FormComponenets/SubText';

export default function Address({ item, handleSettingsClick, isFormBuilder, relationFieldName, isRelation = false }) {
  const {
    subtext,
    street_show = true,
    city_show = true,
    state_show = true,
    country_show = true,
    zip_show = true,
    required = false,
  } = item || {};
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const rules = isFormBuilder
    ? {}
    : {
        required: required ? 'Required Field' : false,
      };

  return (
    <div className="w-100">
      <LabelName>Address{required && <span className="danger-text"> *</span>}</LabelName>
      <div className="d-flex w-100 gap-3">
        {street_show && (
          <div className="d-flex align-items-center w-100 flex-wrap">
            <Controller
              name={isRelation ? `${relationFieldName}street` : `contact_data.street`}
              rules={rules}
              control={control}
              render={({ field }) => (
                <InputText
                  style={{ pointerEvents: isFormBuilder ? 'none' : 'auto' }}
                  type="text"
                  placeholder="Type in"
                  id={field.name}
                  className="w-100 new-task-popup input-shadow"
                  onChange={(e) => field.onChange(e.target.value)}
                  value={field.value || ''}
                  ref={isFormBuilder ? null : field.ref}
                />
              )}
            />
            <div className="help-text-label w-100">Street</div>
            <RequiredValidation field={isRelation ? `${relationFieldName}street` : `contact_data.street`} errors={errors} />
          </div>
        )}
        {city_show && (
          <div className="d-flex align-items-center w-100 flex-wrap">
            <Controller
              name={isRelation ? `${relationFieldName}city` : `contact_data.city`}
              control={control}
              rules={rules}
              render={({ field, fieldState }) => (
                <InputText
                  type="text"
                  placeholder="Type in"
                  id={field.name}
                  style={{ pointerEvents: isFormBuilder ? 'none' : 'auto' }}
                  className={classNames({ 'p-invalid': fieldState.invalid, 'w-100 new-task-popup input-shadow': true })}
                  onChange={(e) => field.onChange(e.target.value)}
                  value={field.value || ''}
                  ref={isFormBuilder ? null : field.ref}
                />
              )}
            />
            <div className="help-text-label w-100">City</div>
            <RequiredValidation field={isRelation ? `${relationFieldName}city` : `contact_data.city`} errors={errors} />
          </div>
        )}
      </div>
      <div className="d-flex gap-3 mt-2">
        {state_show && (
          <div className="d-flex align-items-center w-100 flex-wrap">
            <Controller
              name={isRelation ? `${relationFieldName}state` : `contact_data.state`}
              control={control}
              rules={rules}
              render={({ field }) => (
                <Dropdown
                  id={field.name}
                  options={state_list}
                  className="w-100"
                  onChange={(e) => field.onChange(e.value)}
                  value={field.value}
                  placeholder="Select"
                  optionLabel="label"
                  optionValue="value"
                  style={{ pointerEvents: isFormBuilder ? 'none' : 'auto' }}
                  inputRef={isFormBuilder ? null : field.ref}
                />
              )}
            />
            <div className="help-text-label w-100">State</div>
            <RequiredValidation field={isRelation ? `${relationFieldName}state` : `contact_data.state`} errors={errors} />
          </div>
        )}
        {zip_show && (
          <div className="d-flex align-items-center w-100 flex-wrap">
            <Controller
              name={isRelation ? `${relationFieldName}zip` : `contact_data.zip`}
              control={control}
              rules={rules}
              render={({ field }) => (
                <InputText
                  keyfilter={'pnum'}
                  maxLength={5}
                  placeholder="Type in"
                  id={field.name}
                  style={{ pointerEvents: isFormBuilder ? 'none' : 'auto' }}
                  className="w-100 new-task-popup input-shadow"
                  value={field.value || ''}
                  onChange={(e) => field.onChange(e.target.value)}
                  ref={isFormBuilder ? null : field.ref}
                />
              )}
            />
            <div className="help-text-label w-100">Postal/ Zip Code</div>
            <RequiredValidation field={isRelation ? `${relationFieldName}zip` : `contact_data.zip`} errors={errors} />
          </div>
        )}
      </div>
      {country_show && (
        <div className="d-flex gap-3 mt-2">
          <div className="d-flex align-items-center flex-wrap">
            <Controller
              name={isRelation ? `${relationFieldName}country` : `contact_data.country`}
              control={control}
              rules={rules}
              render={({ field }) => (
                <Dropdown
                  id={field.name}
                  options={countriesList}
                  className="w-100"
                  onChange={(e) => field.onChange(e.value)}
                  value={field.value}
                  placeholder="Select"
                  optionLabel="name"
                  optionValue="name"
                  style={{ pointerEvents: isFormBuilder ? 'none' : 'auto' }}
                  inputRef={isFormBuilder ? null : field.ref}
                />
              )}
            />
            <div className="help-text-label w-100">Country</div>
            <RequiredValidation field={isRelation ? `${relationFieldName}country` : `contact_data.country`} errors={errors} />
          </div>
        </div>
      )}
      <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
    </div>
  );
}
